var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current  text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M9.24952 7.79383C9.34399 7.66251 9.4489 7.50174 9.58269 7.28496C9.63156 7.20577 9.76481 6.98593 9.86404 6.82221L9.86412 6.82208L9.9759 6.63788C11.0812 4.82985 11.8847 4 13.3335 4H20.0002V6.66667H13.3335C13.2179 6.66667 12.8542 7.0423 12.2511 8.02878L12.1541 8.18863L12.1539 8.18896C12.0538 8.35407 11.9081 8.59449 11.852 8.68545C11.6881 8.95109 11.5518 9.15984 11.4143 9.35101C10.8167 10.1819 10.2193 10.6667 9.3335 10.6667H5.3335C4.59712 10.6667 4.00016 11.2636 4.00016 12V24C4.00016 24.7364 4.59712 25.3333 5.3335 25.3333H26.6668C27.4032 25.3333 28.0002 24.7364 28.0002 24V16H30.6668V24C30.6668 26.2091 28.876 28 26.6668 28H5.3335C3.12436 28 1.3335 26.2091 1.3335 24V12C1.3335 9.79086 3.12436 8 5.3335 8H9.08842C9.13281 7.94925 9.18723 7.88044 9.24952 7.79383ZM22.6668 10.6667V8H25.3335V5.33333H28.0002V8H30.6668V10.6667H28.0002V13.3333H25.3335V10.6667H22.6668ZM16.0002 24C12.3183 24 9.3335 21.0152 9.3335 17.3333C9.3335 13.6514 12.3183 10.6667 16.0002 10.6667C19.6821 10.6667 22.6668 13.6514 22.6668 17.3333C22.6668 21.0152 19.6821 24 16.0002 24ZM16.0002 21.3333C18.2093 21.3333 20.0002 19.5425 20.0002 17.3333C20.0002 15.1242 18.2093 13.3333 16.0002 13.3333C13.791 13.3333 12.0002 15.1242 12.0002 17.3333C12.0002 19.5425 13.791 21.3333 16.0002 21.3333Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }